import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Table } from 'reactstrap';
import Link from 'next/link';
import _ from 'lodash';
// @ts-expect-error these exist in each respective front end project
// eslint-disable-next-line import/no-unresolved
import composeUrl from 'app/config/compose-url';
import domainModel from 'domain-model';
import PriceSpan from '../PriceSpan';
import WarehouseStatusIndicator from './WarehouseStatusIndicator';

function ArticleDetails({
  article,
  procurementArticle,
  shopConfig,
  authentication,
}) {
  const {
    supplier,
    organization,
    ingredientsDeclaration,
    nutritionDeclaration,
    displayContainer,
    alcoholPercentage,
    articleNumber,
    brand,
    colliSize,
    GTIN,
    supplierArticleNumber,
    displayOrigin,
    displayWarehouseDeliveryStatus,
    displayOrderUnitSize,
    vintage,
    grapes,
    articleLinks,
  } = article;
  const isPurchasing = !shopConfig;
  return (
    <>
      <Row className="mt-4">
        <h4 className="text-gray-800">Produktdetaljer</h4>
      </Row>
      <Row>
        {organization &&
          !procurementArticle &&
          (isPurchasing ||
            !domainModel.shopConfig.isWhitelabel(shopConfig)) && (
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <div>
                <strong className="text-sm">
                  Leverantör
                  <br />
                </strong>
                <span className="article-detail-value">
                  {isPurchasing && (
                    <Link
                      href={`/app/supplier-organizations/${organization.id}`}
                    >
                      {organization.name}
                    </Link>
                  )}
                  {!isPurchasing && (
                    <Link
                      href={`/supplier-organizations/${encodeURIComponent(
                        organization.name,
                      )}`}
                    >
                      {organization.name}
                    </Link>
                  )}
                </span>
              </div>
            </Col>
          )}
        {supplier && domainModel.shopConfig.isWhitelabel(shopConfig) && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Leverantör
                <br />
              </strong>
              <span className="article-detail-value">
                <Link href={composeUrl('supplier', supplier)}>
                  {supplier.name}
                </Link>
              </span>
            </div>
          </Col>
        )}
        {brand?.name && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Varumärke
                <br />
              </strong>
              <span className="article-detail-value">
                {isPurchasing && brand.name}
                {shopConfig && (
                  <Link href={`/brands/${brand.id}`}>
                    <span title={`/brands/${brand.name}`}>{brand.name}</span>
                  </Link>
                )}
              </span>
            </div>
          </Col>
        )}
        {articleNumber && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Artikelnummer
                <br />
              </strong>
              <span className="article-detail-value">{articleNumber}</span>
            </div>
          </Col>
        )}

        {supplierArticleNumber && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Leverantörens artikelnummer
                <br />
              </strong>
              <span className="article-detail-value">
                {supplierArticleNumber}
              </span>
            </div>
          </Col>
        )}
        {!isPurchasing && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Pris
                <br />
              </strong>
              <span className="article-detail-value">
                {authentication.isAuthenticated ? (
                  <>
                    <span className="text-gray-900 text-nowrap">
                      <strong className="text-sm">
                        {displayOrderUnitSize}
                      </strong>
                    </span>
                    {' á '}
                    <PriceSpan
                      pricedArticle={article}
                      fontSize="normal"
                      showOriginalPrice={!isPurchasing}
                    />
                  </>
                ) : (
                  <span>Logga in för att se priset</span>
                )}
              </span>
            </div>
          </Col>
        )}
        {!procurementArticle && colliSize && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Antal styck per förpackning
                <br />
              </strong>
              <span className="article-detail-value">{colliSize}</span>
            </div>
          </Col>
        )}

        {!procurementArticle && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <strong className="text-sm">
              Förpackning
              <br />
            </strong>
            <span className="article-detail-value">{displayContainer}</span>
          </Col>
        )}

        {GTIN && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                GTIN
                <br />
              </strong>
              <span className="article-detail-value">{GTIN}</span>
            </div>
          </Col>
        )}

        {_.isNumber(alcoholPercentage) && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Alkohol
                <br />
              </strong>
              <span className="article-detail-value">{alcoholPercentage}%</span>
            </div>
          </Col>
        )}

        {!isPurchasing && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Lager och Leverans info
                <br />
              </strong>
              {authentication.isAuthenticated ? (
                <>
                  <WarehouseStatusIndicator article={article} />
                  <span className="article-detail-value">
                    {displayWarehouseDeliveryStatus}
                  </span>
                </>
              ) : (
                <span className="article-detail-value">
                  Logga in för att se lagerstatus
                </span>
              )}
            </div>
          </Col>
        )}

        {displayOrigin && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Ursprung
                <br />
              </strong>
              <span className="article-detail-value">{displayOrigin}</span>
            </div>
          </Col>
        )}
        {vintage && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Årgång
                <br />
              </strong>
              <span className="article-detail-value">{vintage}</span>
            </div>
          </Col>
        )}
        {grapes && (
          <Col xs={12} sm={6} lg={4} className="mb-2">
            <div>
              <strong className="text-sm">
                Druva
                <br />
              </strong>
              <span className="article-detail-value">{grapes}</span>
            </div>
          </Col>
        )}
      </Row>

      {ingredientsDeclaration && (
        <Row className="mt-4 ">
          <Col>
            <strong className="text-sm">
              Ingredienser
              <br />
            </strong>
            <div
              suppressHydrationWarning
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: ingredientsDeclaration,
              }}
            />
          </Col>
        </Row>
      )}

      {nutritionDeclaration && (
        <Row className="mt-4">
          <Col>
            <strong className="text-sm">
              Näringsinnehåll
              <br />
            </strong>
            <div
              suppressHydrationWarning
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: nutritionDeclaration,
              }}
            />
          </Col>
        </Row>
      )}
      {articleLinks && articleLinks.length > 0 && (
        <Row className="mt-4">
          <Col>
            <strong className="text-sm">
              Länkar
              <br />
            </strong>

            <Table striped bordered hover>
              <tbody>
                {articleLinks.map((link, index) => (
                  <tr key={index}>
                    <td>
                      <Link href={link.href} target="_blank">
                        {link.name}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      )}
    </>
  );
}

ArticleDetails.propTypes = {
  article: PropTypes.object.isRequired,
  procurementArticle: PropTypes.object,
  shopConfig: PropTypes.object,
};

ArticleDetails.defaultProps = {
  shopConfig: null,
  procurementArticle: null,
};
const mapStateToProps = ({ authentication }) => ({
  authentication,
});
export default connect(mapStateToProps)(ArticleDetails);
